export default {
	'planned-visit': 'Planned visit',
}
